import { DiscussionEmbed } from 'disqus-react'
import { Grid } from './grid'

export function Disqus({
  identifier,
  title,
  url,
}: {
  identifier: string
  title: string
  url: string
}) {
  return (
    <Grid>
      <div className="col-span-full mb-12">
        <DiscussionEmbed
          shortname="vinhnguyen"
          config={{
            url,
            identifier,
            title,
            language: 'en',
          }}
        />
      </div>
    </Grid>
  )
}
